import { cwslapi } from "../index";


// 获取日志记录 —— 日志管理
export const getRecordListApi = (data) => { 
  return cwslapi({
    url: "/record/getRecordList",
    method: "post",
    data,
  });
};

